export const data = function() {
  return {
    isDebug: true,
    loading: false,
    actionItemID: 0,
    tabs: [
      { name: 'actionItemDetails', label: 'Detail' },
      { name: 'actionItemNotes', label: 'Notes' }
    ],
    styles: {
      mainContainer: {
        minHeight: '1000px'
      }
    },
    transitionName: 'slide-down',
    showUploadModal: false
  }
}
